export default {"src":"/_next/static/media/seriesPlaceholderSquare.fae943a5.svg","height":64,"width":64};